export default state =>
  state.category.childLinks?.map(childLink => ({
    ...childLink,
    linkUrl: `${childLink.linkUrl}#ctaref-cat_header`
  })) || [];
